import React from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";

import { Button, TextField, Grid, Typography, MenuItem, Switch } from "@material-ui/core";
import Loading from "../loadingSpinner/Loading";
import ConfirmationModal from "../modal/ConfirmationModal";
import FestivalModal from "./festivalModal/FestivalModal";
import agent from "../../agent";
import SectionHeader from "../common/SectionHeader";
import ApplyToPlayModal from "../searchPage/modal/ApplyToPlayModal";

@inject("privacyProfileStore", "templateStore", "authStore", "userStore", "profileStore", "userFestivalStore", "profileStore", "agentActStore", "billingStore", "hgBillingStore", "bookingRequestStore")
@withRouter
@observer
class Privacy extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            actConfirmationState: false,
            openFestivalModal: false,
            selectedActId: undefined,
            showApplyToPlayModal: false,
            hasReferralAgent: false
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        const userId = this.props.userStore.currentUser?.email;
        if (userId) {
            this.props.profileStore.getApplyToPlayCustomRegisterUser(encodeURIComponent(userId))
                .then(referralData => {
                    const agentId = referralData?.referralAgentId || referralData?.agentId;
                   
                    if (agentId) {
                        this.props.profileStore.getProfileById(agentId)
                            .then(agentProfile => {
                                this.setState({
                                    referralAgentProfile: agentProfile,
                                    hasReferralAgent: true // valid agentId
                                });
                            })
                            .catch(err => {
                                console.error("❌ [ERROR] Failed to fetch agent profile:", err);
                                this.setState({ referralAgentProfile: null, hasReferralAgent: false });
                            });
                    } else {
                        this.setState({ referralAgentProfile: null, hasReferralAgent: false });
                    }
                })
                .catch(err => {
                    console.error("❌ [ERROR] Failed to fetch referral data:", err);
                    this.setState({ referralAgentProfile: null, hasReferralAgent: false });
                });
        }

        // set type
        this.props.privacyProfileStore.setType(this.props.templateStore.getType(this.props.type));

        if (this.props.type === "act") {
            //this.props.userFestivalStore.getUserFestival();
            this.props.userFestivalStore.getUserFestivalForAct(this.props.profileId);
        }

        this.props.profileStore.getUserActList();

        this.props.privacyProfileStore
            .loadInitialData(this.props.profileId)
            .then(() => {})
            .finally(() => {
                this.setState({ isLoading: false });
                window.scrollTo(0, 0);
            });
    }

    componentWillUnmount() {
        this.props.userFestivalStore.setUserActFestivals(undefined);
    }

    handleVisibilityChange = e => this.props.privacyProfileStore.setVisibility(e.target.value);

    handleBack = () => {
        if (this.props.type === "venue") {
            const { profile } = this.props.profileStore;
            this.props.history.push(`/venues/${profile.id}/edit/contract`);
        }
        if (this.props.type === "act") {
            this.props.history.replace(`/myact/edit/${this.props.match.params.id}/toc`);
        }
        const { editProfileActiveStep } = this.props.templateStore;
        this.props.templateStore.setEditProfileActiveStep(editProfileActiveStep - 1);
    };

    openFestivalModal = () => {
        this.setState({
            ...this.state,
            openFestivalModal: true
        });
    };

    handleSubmitForm = async (e) => {
        e.preventDefault();
        const { currentUser } = this.props.userStore;
        const { userActFestival } = this.props.userFestivalStore;
        this.setState({ isLoading: true });

        var isConsultantInvitation = this.props.match.params.role && this.props.match.params.role === "consultant";

        if ((this.props.match.params.new === "new" && !isConsultantInvitation) || (this.props.type === 'venue' && this.props.match.params.tab === 'privacy')) {
            let candidateCustomer = {
                userId: currentUser.sub,
                email: currentUser.email,
                given_name: currentUser.given_name,
                family_name: currentUser.family_name,
                userType: 0
            };

            if (this.props.type == "musician") {
                candidateCustomer.userType = 1;
                await agent.Billing.createCustomer(candidateCustomer);
            } else if (this.props.type == "agent") {
                candidateCustomer.userType = 2;
                await agent.Billing.createCustomer(candidateCustomer);
            }
        }

        this.props.privacyProfileStore.submit().then((profile) => {
            this.setState({ isLoading: false });
            const { isAgentAct } = this.props.agentActStore;

            // redirect
            const handleRedirect = () => {
                if (currentUser && currentUser.status === 50) {
                    if (userActFestival) {
                        this.openFestivalModal();
                    } else {
                        switch (this.props.type) {
                            case "agent":
                                this.props.profileStore.loadProfiles();
                                this.props.history.push("/agent");
                                break;
                            case "musician":
                                this.props.profileStore.loadProfiles();
                                this.props.history.push("/musician");
                                break;
                            case "staff":
                                this.props.profileStore.loadProfiles();
                                this.props.templateStore.openSnackbar("Profile saved");
                                this.props.history.push("/staff");
                                break;
                            case "venue":
                                this.props.history.push("/venues");
                                break;
                            case "act":
                                if (isAgentAct) {
                                    this.props.history.push("/agent/actroster/myact");
                                    this.props.agentActStore.setIsAgentAct(false);
                                    break;
                                }
                                this.props.history.push("/myact");
                                break;
                            case "production":
                                this.props.history.push("/production");
                                break;
                            case "dj":
                                this.props.history.push("/dj");
                                break;
                            case "consultant":
                                this.props.history.push("/agent");
                                break;
                            case "privateHire":
                                this.props.profileStore.loadProfiles();
                                this.props.history.push("/privateHire/gig");
                                break;
                            default:
                                this.props.history.push("/welcome");
                                break;
                        }
                    }
                } else {
                    if (userActFestival) {
                        this.openFestivalModal();
                    } else {
                        if (this.props.type === "act") {
                            this.setState({ actConfirmationState: true });
                        } else if (this.props.type === "consultant") {
                            this.props.history.push("/agent");
                        } else if (this.props.type === "privateHire") {
                            this.props.history.push("/account/setting/privatehirelock");
                        } else {
                            Promise.all([
                                this.props.userStore.pullUser(),
                                this.props.bookingRequestStore.getBookingCountThisMonth()
                            ]).then(() => {
                                this.props.history.push("/welcome");
                            });
                        }
                    }
                }
            };

            if (this.props.type === "act" && this.state.hasReferralAgent) {
                this.setState({
                    showApplyToPlayModal: true,
                    pendingRedirect: handleRedirect
                });
            } else {
                handleRedirect();
            }
        });
    };

    anyError(field) {
        if (!this.props.authStore.errors) return false;
        if (!this.props.authStore.errors[field]) return false;
        return true;
    }

    errorText(field) {
        if (!this.props.authStore.errors) return null;
        if (!this.props.authStore.errors[field]) return null;
        return this.props.authStore.errors[field];
    }

    handleActConfirmationGotoDashboard = () => {
        this.props.userStore.completeUser().then(() => {
            this.props.history.push("/musician");
        });
    };

    handleCreateAnotherAct = () => {
        this.props.userStore.pullUser().then(() => {
            this.props.history.push("/welcome");
        });
    };

    handleCloseActConfirmationState = () => {
        this.setState({
            ...this.state,
            actConfirmationState: false
        });
    };

    handleAllowAgent = e => {
        this.props.privacyProfileStore.setAllowInvitesAgent(e.target.checked)
    }

    handleAllowAct = e => {
        this.props.privacyProfileStore.setAllowInvitesMusician(e.target.checked)
    }

    handleAllowMusicianApplyToActLineup = e => {
        this.props.privacyProfileStore.setAllowMusicianApplyToActLineup(e.target.checked)
    }

    handleIncludeInHotgiggityHire = e => {
        this.props.privacyProfileStore.setIncludeHotgiggityHire(e.target.checked)
    }

    showApplyToPlayModal = () => {
        this.setState({
            ...this.state,
            showApplyToPlayModal: true
        });
    };

    hideApplyToPlayModal = async () => {
        const { pendingRedirect } = this.state;
        const { currentUser } = this.props.userStore;
        const userId = currentUser?.email || currentUser?.sub;

        this.setState({ isLoading: true });

        try {
            if (userId) {
                //delete referral after complete apllying
                await agent.ApplyToPlayCustomRegisterUser.delete(encodeURIComponent(userId));
            }
        } catch (error) {
            console.error("Failed to delete referral agent:", error);
        } finally {
            this.setState({
                showApplyToPlayModal: false,
                isLoading: false,
                pendingRedirect: null
            }, () => {
                if (typeof pendingRedirect === "function") {
                    pendingRedirect();
                }
            });
        }
    };

    render() {
        const { id, visibility, allowInvitesFromAgent, allowInvitesFromMusician, allowMusicianApplyToActLineup, includeInHotgiggityHire, isConsultant } = this.props.privacyProfileStore;
        const { editProfileActiveStep } = this.props.templateStore;
        const type = this.props.type;
        const steps = this.props.templateStore.getSteps(type);
        const { isLoading, actConfirmationState, openFestivalModal } = this.state;
        const { profileStore, privacyProfileStore } = this.props;
        const agentProfile = this.state.referralAgentProfile || profileStore.profile || {};
        const agentId = agentProfile.id || agentProfile.agentId || profileStore.applyToPlayReferral?.referralAgentId || profileStore.applyToPlayReferral?.agentId || null; 
        const agentName = agentProfile.profileName;
        const agentImageObj = agentProfile.profileImage;
        const agentImage = typeof agentImageObj === "string"
            ? agentImageObj
            : (agentImageObj?.url200 || agentImageObj?.url || agentImageObj?.url400 || "");

        return (
            <div className="Profile-Privacy">
                <ConfirmationModal
                    open={actConfirmationState}
                    title="Act Confirmation"
                    message={`Do you want to create another act?`}
                    closeHandler={this.handleCloseActConfirmationState}
                    confirmationHandler={this.handleCreateAnotherAct}
                    declineHandler={this.handleActConfirmationGotoDashboard}
                    confirmationLabel="Create Another Act"
                    declineLabel="No, Go to Dashboard"
                />

                {type == "act" && agentId != null ? 
                    <ApplyToPlayModal
                        open={this.state.showApplyToPlayModal}
                        onClose={this.hideApplyToPlayModal}
                        profileName={agentName}
                        profile={agentProfile} 
                        profileImage={agentImage}
                    /> : null}

                {type === "act" ? <FestivalModal open={openFestivalModal} actId={id} /> : null}

                <form onSubmit={this.handleSubmitForm} className="form-relative">
                    <Loading showed={isLoading} />
                    <Grid container spacing={24}>
                        <Grid item xs={12} lg={12}>
                            <SectionHeader
                                title="Privacy"
                                helpText={type === "act"
                                    ? "Manage your act privacy. You choose who can see and find you on Hot Giggity."
                                    : "Manage your privacy. You choose who can see and find you on Hot Giggity."}
                            />
                            <Grid container spacing={8}>
                                <Grid item xs={12}>
                                    <TextField
                                        id="visibility"
                                        label="Visibility"
                                        margin="normal"
                                        fullWidth
                                        value={visibility || "public"}
                                        onChange={this.handleVisibilityChange}
                                        error={this.anyError("visibility")}
                                        helperText={this.errorText("visibility")}
                                        select
                                    >
                                        {/* <MenuItem value="contact">My Contact</MenuItem> */}
                                        <MenuItem value="private">Private</MenuItem>
                                        <MenuItem value="public">Searchable by Everyone</MenuItem>
                                    </TextField>
                                </Grid>

                            </Grid>
                        </Grid>

                    </Grid>

                        {/* {((type === "agent" && this.props.match.params.role!=="consultant") || type === "musician" || type === "act" ) && (
                            <Grid container spacing={24}>
                                <Grid item xs={12} lg={12}>
                                    <SectionHeader
                                        title="Include profile in Hot Giggity hire"
                                        helpText={type === "agent" || type === "consultant" ? "Shows or hides profile in Hot Giggity hire search result" : "Show profile in Hot Giggity hire"}
                                    />
                                    <div>
                                        <Switch checked={includeInHotgiggityHire} onChange={this.handleIncludeInHotgiggityHire} color="primary" />{" "}
                                        Show profile in Hot Giggity hire
                                    </div>
                                </Grid>
                            </Grid>
                        )} */}
                        {/* {type === "agent" && 
                            <Fragment>
                                <Grid container spacing={24}>
                                    <Grid item xs={12} lg={12}>
                                        <SectionHeader
                                            title="Allow apply act line up"
                                            helpText="Shows or hides the \"Apply to act Lineup\" button on act search"
                                        />
                                        <div>
                                            <Switch checked={allowMusicianApplyToActLineup} onChange={this.handleAllowMusicianApplyToActLineup} color="primary" />{" "}
                                            Allow musician apply to your act lineup
                                        </div>
                                    </Grid>
                                </Grid>
                            </Fragment>
                        } */}
                       {(type === "venue" || (type === "agent" && this.props.match.params.role!=="consultant")) && (
                            <>
                                <Grid container spacing={24}>
                                    <Grid item xs={12} lg={12}>
                                        <SectionHeader
                                            title="Allow Artists to Apply To Play"
                                            helpText={type === "agent" 
                                                ? "When enabled, artists and acts can send you requests to join your agency roster. Disable this to prevent unsolicited roster requests."
                                                : "When enabled, artists and acts can send you requests to perform at your venue. Disable this to prevent unsolicited performance requests."
                                            }
                                        />
                                        <div>
                                            <Switch checked={allowInvitesFromMusician} onChange={this.handleAllowAct} color="primary" />{" "}
                                            Allow Artists to Apply To Play
                                        </div>
                                    </Grid>
                                </Grid>
                                {type !== "agent" && 
                                    <Grid container spacing={24}>
                                        <Grid item xs={12} lg={12}>
                                            <SectionHeader
                                                title="Allow Agents to Request Booking Access"
                                                helpText="When enabled, booking agents can request access to book acts at your venue. Disable this if you prefer to manage bookings directly."
                                            />
                                            <div>
                                                <Switch checked={allowInvitesFromAgent} onChange={this.handleAllowAgent} color="primary" />{" "}
                                                Allow Agents to Request Booking Access
                                            </div>
                                        </Grid>
                                    </Grid>
                                }

                            </>
                        )}

                            <Grid item xs={12}>
                                <div className="action">
                                    <Button disabled={editProfileActiveStep === 0} onClick={this.handleBack}>
                                        Back
                                    </Button>
                                    {id && (
                                        <Button variant="contained" color="primary" type="submit">
                                            {editProfileActiveStep === steps.length - 1 || isConsultant ? "Save/Finish" : "Next"}
                                        </Button>
                                    )}
                                </div>
                            </Grid>
                        

                    
                </form>
            </div>
        );
    }
}

export default Privacy;
